import React, { useState, useContext, useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import firebase from "gatsby-plugin-firebase"
import { AuthContext } from "../context/auth"
import publicIp from "public-ip"
import { injectIntl, Link, navigate } from "gatsby-plugin-intl"
import axios from "axios"
import {
  Button,
  Select,
  InputLabel,
  MenuItem,
  CssBaseline,
  TextField,
  Grid,
  // Box,
  Typography,
  makeStyles,
  Container,
} from "@material-ui/core"
import { graphql } from "gatsby"
import usePaises from "../hooks/usePaises"

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    textDecoration: "none",
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    padding: 8,
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    padding: 8,
  },
}))

const Registro = ({ intl, data }) => {
  const {
    nombre,
    bienvenida,
    link_planilla_registro,
    ingreso_habilitado,
    alert_ingreso_habilitado,
    boton_registrarme,
    boton_volver_login,
    label_nombre,
    label_apellido,
    label_email,
    label_clave,
    label_profesion,
    label_telefono,
    label_pais,
    alert_campos_obligatorios,
  } = data.strapiRegistro

  const currentLocale = intl.locale
  const [pais, setPais] = useState("")
  const paises = usePaises()
  paises.sort(function (a, b) {
    let left = a.nombre_pais
    let right = b.nombre_pais
    return left === right ? 0 : left > right ? 1 : -1
  })
  //const [categoria, setCategoria] = useState("")
  //const [ramo, setRamo] = useState("")
  //const [interesado, setInteresado] = useState(true)

  /*   const handleChangeInteresado = event => {
    setInteresado(event.target.checked)
  }


  const handleChangeCategoria = event => {
    setCategoria(event.target.value)
  }
  const handleChangeRamo = event => {
    setRamo(event.target.value)
  } */
  const handleChangePais = event => {
    setPais(event.target.value)
  }
  const [dataRegistro, setDataRegistro] = useState({
    email: "",
    password: "",
    error: null,
    nombre: "",
    apellido: "",
    profesion: "",
    telefono: "",
    /*  empresa: "",
    cargo: "",
    whatsapp: "",
    ciudad: "",
    instagram: "",
    linkedin: "",
    sitioweb: "", */
  })

  const { user, setUser } = useContext(AuthContext)
  const [btnDisabled, setBtnDisabled] = useState(false)

  const handleChange = e => {
    setDataRegistro({ ...dataRegistro, [e.target.name]: e.target.value })
  }
  const CodigoPais = pais => {
    let alfa2
    paises.filter(function (paisFiltrado) {
      if (
        paisFiltrado.nombre.es.toLowerCase().includes(pais.toLowerCase()) ||
        paisFiltrado.nombre.en.toLowerCase().includes(pais.toLowerCase()) ||
        paisFiltrado.nombre.pt.toLowerCase().includes(pais.toLowerCase())
      ) {
        if (
          paisFiltrado.nombre.es.toLowerCase() === pais.toLowerCase() ||
          paisFiltrado.nombre.en.toLowerCase() === pais.toLowerCase() ||
          paisFiltrado.nombre.pt.toLowerCase() === pais.toLowerCase()
        ) {
          alfa2 = paisFiltrado.alfa2
        }
      }
    })
    return alfa2
  }
  /****************
   * codigo pais fin
   */

  const handleSubmit = async e => {
    e.preventDefault()
    setDataRegistro({ ...dataRegistro, error: null })
    if (
      dataRegistro.nombre !== "" &&
      dataRegistro.apellido !== "" &&
      dataRegistro.email !== "" &&
      dataRegistro.password !== "" &&
      dataRegistro.telefono !== "" &&
      dataRegistro.profesion !== "" &&
      pais !== ""
    ) {
      /*    try { */
      // const result = await firebase
      firebase
        .auth()
        .createUserWithEmailAndPassword(
          dataRegistro.email.trim(),
          dataRegistro.password
        )
        .then(result2 => {
          setUser(result2.user)
          setBtnDisabled(true)

          grabarPlanilla()

          // result2.user
          //   .sendEmailVerification()
          //   .then(function () {
          //     // Email sent.
          //     alert(
          //       "Por favor verifique su email y haga click en el vinculo para poder ingresar"
          //     )
          //   })
          //   .catch(function (error) {
          //     // An error happened.
          //   })
        })
        .catch(function (error) {
          error.message ===
          "The email address is already in use by another account."
            ? alert(
                currentLocale === "en"
                  ? "The email address is already in use by another account."
                  : currentLocale === "pt"
                  ? "Este e-mail já está registado"
                  : "Este correo electrónico ya está registrado."
              )
            : error.message === "The email address is badly formatted."
            ? alert(
                currentLocale === "en"
                  ? "The email address is badly formatted."
                  : currentLocale === "pt"
                  ? "O e-mail informado não é um e-mail válido! Revise os dados inseridos."
                  : "El e-mail ingresado no es un e-mail válido! Revisar los datos ingresados."
              )
            : error.message === "Password should be at least 6 characters"
            ? alert(
                currentLocale === "en"
                  ? "Password should be at least 6 characters"
                  : currentLocale === "pt"
                  ? "Password should be at least 6 characters"
                  : "La clave no puede ser inferior a 6 caracteres"
              )
            : alert(`Comunique el error al proveedor: ${error.message}`)
        })
    } else {
      alert(
        currentLocale === "en"
          ? alert_campos_obligatorios.en
          : currentLocale === "pt"
          ? alert_campos_obligatorios.pt
          : alert_campos_obligatorios.es
      )
    }
  }
  // para que no hagan log de 2 ip diferentes
  const getClientIp = async () =>
    await publicIp.v4({
      fallbackUrls: ["https://ifconfig.co/ip"],
    })

  const [ip, setIp] = useState("")
  useEffect(() => {
    getClientIp().then(result => setIp(result))
  }, [])

  const docRef = firebase.firestore().collection("usuarios")

  useEffect(() => {
    if (user != null) {
      firebase
        .firestore()
        .collection("usuarios")
        .doc(user.uid)
        .get()
        .then(value => {
          if (value.exists) {
            navigate("/inicio")
          } else {
            let guardarDocumento = {
              nombre: dataRegistro.nombre.trim(),
              apellido: dataRegistro.apellido.trim(),
              email: dataRegistro.email.toLowerCase().trim(),
              profesion: dataRegistro.profesion.trim(),
              pais: pais,
              codpais: CodigoPais(pais),
              telefono: dataRegistro.telefono,
              ip: ip,
              uid: user.uid,
              front: true,
            }
            docRef
              .doc(user.uid)
              .set(guardarDocumento)
              .then(res => {
                user
                  .updateProfile({
                    displayName: `${dataRegistro.nombre.trim()} ${dataRegistro.apellido.trim()}`,
                  })
                  .then(function () {
                    console.log("ingreso_habilitado", ingreso_habilitado)
                    if (ingreso_habilitado) {
                      navigate("/inicio")
                    } else {
                      alert(
                        currentLocale === "en"
                          ? alert_ingreso_habilitado.en
                          : currentLocale === "pt"
                          ? alert_ingreso_habilitado.pt
                          : alert_ingreso_habilitado.es
                      )
                      firebase.auth().signOut() //ACTIVAR PARA LA CONFIRMACION DEL EMAIL
                      navigate("/") //ACTIVAR PARA LA CONFIRMACION DEL EMAIL
                    }
                  })
                  .catch(function (error) {})
              })
          }
        })
    }
  }, [user])

  const grabarPlanilla = () => {
    axios
      .post(link_planilla_registro, {
        nombre: dataRegistro.nombre.trim(),
        apellido: dataRegistro.apellido.trim(),
        email: dataRegistro.email.toLowerCase().trim(),
        profesion: dataRegistro.profesion.trim(),
        pais: pais,
        telefono: dataRegistro.telefono.trim(),
        fecha: Date.now().toString(),
        /*     whatsapp: dataRegistro.whatsapp,
          ciudad: dataRegistro.ciudad,
          instagram: dataRegistro.instagram,
          linkedin: dataRegistro.linkedin,
          categoria: categoria,
          ramo: ramo,
          empresa: dataRegistro.empresa,
          cargo: dataRegistro.cargo,
          sitioweb: dataRegistro.sitioweb,
          interesado: interesado, */
      })
      .catch(error => {
        console.error("Error enviando registro a planilla principal", error)
      })

    axios
      .post("https://servidor.virtualeventweb.com:1340/plataforma-registros", {
        nombre: dataRegistro.nombre.trim(),
        apellido: dataRegistro.apellido.trim(),
        email: dataRegistro.email.toLowerCase().trim(),
        profesion: dataRegistro.profesion.trim(),
        pais: pais,
        telefono: dataRegistro.telefono.trim(),
        fecha: Date.now().toString(),
      })
      .catch(error => {
        console.error("Error enviando registro a respaldo", error)
      })
  }

  const classes = useStyles()

  /*   const categorias_es = [
    "Fabricante / Productor",
    "Distribuidor / Comprador",
    "Representante de ventas",
    "Servicio",
    "Organización gubernamental",
    "Prensa",
    "Otro",
  ]
  const categorias_en = [
    "Manufacturer / Producer",
    "Distributor / Buyer",
    "Sales representative",
    "Service",
    "Government organization",
    "Press",
    "Other",
  ]
  const categorias_pt = [
    "Fabricante / Produtor",
    "Distribuidor / Comprador",
    "Representante de vendas",
    "Serviço",
    "Organização governamental",
    "Imprensa",
    "Outro",
  ]
  const categorias =
    currentLocale === "en"
      ? categorias_en
      : currentLocale === "pt"
      ? categorias_pt
      : categorias_es */

  /*   const ramos_es = [
    "Industria",
    "Automotor",
    "Aviación y aeroespacial",
    "Materiales de construcción y construcción",
    "Tecnología limpia",
    "Bienes de consumo",
    "Defender y Homeland Security",
    "Educación",
    "Servicio Financiero y Profesional",
    "Alimentos / Agricultura",
    "Tecnologías de la información",
    "Logística, distribución e infraestructura",
    "Ciencias de la vida y tecnología médica",
    "Fabricación",
    "Embarcaciones y equipos marinos",
    "Otro",
  ]
  const ramos_en = [
    "Industry",
    "Automotive",
    "Aviation and aerospace",
    "Building and construction materials",
    "Clean technology",
    "Consumer goods",
    "Defender and Homeland Security",
    "Education",
    "Financial and Professional Service",
    "Food / Agriculture",
    "Information technology",
    "Logistics, distribution, and infrastructure",
    "Life Sciences and Medical Technology",
    "Manufacturing",
    "Marine vessels and equipment",
    "Other",
  ]
  const ramos_pt = [
    "Indústria",
    "Automotivo",
    "Aviação e aeroespacial",
    "Construção e materiais de construção",
    "Tecnologia limpa",
    "Bens de consumo",
    "Defender e Segurança Interna",
    "Educação",
    "Serviço Financeiro e Profissional",
    "Alimentos / Agricultura",
    "Tecnologia da Informação",
    "Logística, distribuição e infraestrutura",
    "Ciências da Vida e Tecnologia Médica",
    "Manufatura",
    "Embarcações e equipamentos marítimos",
    "Outro",
  ]
  const ramos =
    currentLocale === "en"
      ? ramos_en
      : currentLocale === "pt"
      ? ramos_pt
      : ramos_es */

  return (
    <Layout>
      <SEO
        title={
          currentLocale === "en"
            ? nombre.en
            : currentLocale === "pt"
            ? nombre.pt
            : nombre.es
        }
      />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            {currentLocale === "en"
              ? bienvenida.en
              : currentLocale === "pt"
              ? bienvenida.pt
              : bienvenida.es}
          </Typography>

          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="nombre"
              label={
                currentLocale === "en"
                  ? label_nombre.en
                  : currentLocale === "pt"
                  ? label_nombre.pt
                  : label_nombre.es
              }
              type="text"
              id="nombre"
              value={dataRegistro.nombre}
              onChange={handleChange}
            />

            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="apellido"
              label={
                currentLocale === "en"
                  ? label_apellido.en
                  : currentLocale === "pt"
                  ? label_apellido.pt
                  : label_apellido.es
              }
              type="text"
              id="apellido"
              value={dataRegistro.apellido}
              onChange={handleChange}
            />

            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label={
                currentLocale === "en"
                  ? label_email.en
                  : currentLocale === "pt"
                  ? label_email.pt
                  : label_email.es
              }
              name="email"
              autoComplete="email"
              //   autoFocus
              value={dataRegistro.email}
              onChange={handleChange}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label={
                currentLocale === "en"
                  ? label_clave.en
                  : currentLocale === "pt"
                  ? label_clave.pt
                  : label_clave.es
              }
              type="password"
              id="password"
              autoComplete="current-password"
              value={dataRegistro.password}
              onChange={handleChange}
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="profesion"
              label={
                currentLocale === "en"
                  ? label_profesion.en
                  : currentLocale === "pt"
                  ? label_profesion.pt
                  : label_profesion.es
              }
              type="text"
              id="Profesion"
              value={dataRegistro.profesion}
              onChange={handleChange}
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="telefono"
              label={
                currentLocale === "en"
                  ? label_telefono.en
                  : currentLocale === "pt"
                  ? label_telefono.pt
                  : label_telefono.es
              }
              type="tel"
              id="telefono"
              value={dataRegistro.telefono}
              onChange={handleChange}
            />
            <InputLabel id="paisLabel" style={{ padding: 15 }}>
              {currentLocale === "en"
                ? label_pais.en
                : currentLocale === "pt"
                ? label_pais.pt
                : label_pais.es}
            </InputLabel>
            <Select
              style={{ width: "100%", padding: 10 }}
              //labelId="pais"
              id="pais"
              value={pais}
              onChange={handleChangePais}
            >
              {paises.map(pais => (
                <MenuItem value={pais.nombre.es}>
                  {pais.mostrar ? (
                    <>
                      {currentLocale === "en"
                        ? pais.nombre.en
                        : currentLocale === "pt"
                        ? pais.nombre.pt
                        : pais.nombre.es}
                    </>
                  ) : (
                    ""
                  )}
                </MenuItem>
              ))}
            </Select>

            {/*  <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="empresa"
              label={intl.formatMessage({ id: "empresa" })}
              type="text"
              id="empresa"
              value={dataRegistro.empresa}
              onChange={handleChange}
            />
            <InputLabel id="paisLabel" style={{ padding: 15 }}>
              {intl.formatMessage({ id: "pais" })}
            </InputLabel>
            <Select
              style={{ width: "100%", padding: 10 }}
              //labelId="pais"
              id="pais"
              value={pais}
              onChange={handleChangePais}
            >
              {paises.map(pais => (
                <MenuItem value={pais}>{pais}</MenuItem>
              ))}
            </Select>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="cargo"
              label={intl.formatMessage({ id: "cargo" })}
              type="text"
              id="cargo"
              value={dataRegistro.cargo}
              onChange={handleChange}
            />

            <InputLabel id="categoriasLabel" style={{ padding: 5 }}>
              {intl.formatMessage({ id: "categoria" })}
            </InputLabel>
            <Select
              style={{ width: "100%", padding: 5 }}
              id="categoria"
              value={categoria}
              onChange={handleChangeCategoria}
            >
              {categorias.map(categoria => (
                <MenuItem value={categoria}>{categoria}</MenuItem>
              ))}
            </Select>

            <InputLabel id="ramosLabel" style={{ padding: 5 }}>
              {intl.formatMessage({ id: "ramos" })}
            </InputLabel>
            <Select
              style={{ width: "100%", padding: 5 }}
              id="categoria"
              value={ramo}
              onChange={handleChangeRamo}
            >
              {ramos.map(ramo => (
                <MenuItem value={ramo}>{ramo}</MenuItem>
              ))}
            </Select>

            <FormControlLabel
              checked={interesado}
              style={{ padding: 5 }}
              onChange={handleChangeInteresado}
              control={<Checkbox value={interesado} color="primary" />}
              label={intl.formatMessage({ id: "interesado" })}
            />

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="ciudad"
              label={intl.formatMessage({ id: "ciudad" })}
              type="text"
              id="ciudad"
              value={dataRegistro.ciudad}
              onChange={handleChange}
            />

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="telefono"
              label={intl.formatMessage({ id: "telefono" })}
              type="tel"
              id="telefono"
              value={dataRegistro.telefono}
              onChange={handleChange}
            />

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="whatsapp"
              label="Whatsapp"
              type="tel"
              id="whatsapp"
              value={dataRegistro.whatsapp}
              onChange={handleChange}
            />

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="sitioweb"
              label={intl.formatMessage({ id: "sitioweb" })}
              type="text"
              id="sitioweb"
              value={dataRegistro.sitioweb}
              onChange={handleChange}
            />

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="instagram"
              label="Instagram"
              type="text"
              id="instagram"
              value={dataRegistro.instagram}
              onChange={handleChange}
            />

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              name="linkedin"
              label="Linkedin"
              type="text"
              id="linkedin"
              value={dataRegistro.linkedin}
              onChange={handleChange}
            />
 */}
            {dataRegistro.error ? (
              <p style={{ color: "red" }}>{dataRegistro.error}</p>
            ) : null}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              // color="primary"
              disabled={btnDisabled}
              className={classes.submit}
              style={{
                background: `${boton_registrarme.color_fondo}`,
                color: `${boton_registrarme.color_letra}`,
              }}
            >
              {currentLocale === "en"
                ? boton_registrarme.en
                : currentLocale === "pt"
                ? boton_registrarme.pt
                : boton_registrarme.es}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link to={"/"} className={classes.link}>
                  <Button
                    fullWidth
                    variant="contained"
                    //color="primary"
                    className={classes.submit}
                    disabled={btnDisabled}
                    style={{
                      background: `${boton_volver_login.color_fondo}`,
                      color: `${boton_volver_login.color_letra}`,
                    }}
                  >
                    {currentLocale === "en"
                      ? boton_volver_login.en
                      : currentLocale === "pt"
                      ? boton_volver_login.pt
                      : boton_volver_login.es}
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </form>
          {/*    <div style={{ position: "absolute", top: "5%", left: "1%" }}>
            <ListItem
              button
              onClick={() => changeLocale("es")}
              className={classes.boton}
            >
              <ListItemAvatar>
                <Avatar
                  src={imagenesIconosIdiomas[0].node.publicURL}
                  alt="Español"
                />
              </ListItemAvatar>
              <ListItemText>
                <FormattedMessage id="es" />
              </ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={() => changeLocale("en")}
              className={classes.boton}
            >
              <ListItemAvatar>
                <Avatar
                  src={imagenesIconosIdiomas[1].node.publicURL}
                  alt="English"
                />
              </ListItemAvatar>
              <ListItemText>
                <FormattedMessage id="en" />
              </ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={() => changeLocale("pt")}
              className={classes.boton}
            >
              <ListItemAvatar>
                <Avatar
                  src={imagenesIconosIdiomas[2].node.publicURL}
                  alt="Portuguese"
                />
              </ListItemAvatar>
              <ListItemText>
                <FormattedMessage id="pt" />
              </ListItemText>
            </ListItem>
          </div> */}
        </div>
      </Container>
    </Layout>
  )
}

export default injectIntl(Registro)

export const query = graphql`
  query {
    strapiRegistro {
      alert_campos_obligatorios {
        es
        en
        pt
      }
      label_pais {
        es
        en
        pt
      }
      label_telefono {
        es
        en
        pt
      }
      label_profesion {
        es
        en
        pt
      }
      label_clave {
        es
        en
        pt
      }
      label_email {
        es
        en
        pt
      }
      label_apellido {
        es
        en
        pt
      }
      label_nombre {
        es
        en
        pt
      }
      nombre {
        es
        en
        pt
      }
      boton_volver_login {
        es
        en
        pt
        color_fondo
        color_letra
      }
      boton_registrarme {
        es
        en
        pt
        color_fondo
        color_letra
      }
      ingreso_habilitado
      alert_ingreso_habilitado {
        es
        en
        pt
      }
      link_planilla_registro
      bienvenida {
        es
        en
        pt
      }
    }
  }
`
